import { getHsmWebsitesUrl } from './urls';
import { HsmWebsite } from './types';

import {
  HsmBackendHttpClient,
  HsmBackendResponseList,
} from '@/utils/http-client';

export async function getHsmWebsites(jwt: string): Promise<HsmWebsite[]> {
  const client = HsmBackendHttpClient.instance;

  client.setAuthorization(jwt);

  const { result } =
    await client.get<HsmBackendResponseList<HsmWebsite>>(getHsmWebsitesUrl);

  return result;
}
